import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function Calendra({ onChange, value }) {
    const [startDate, setStartDate] = useState(value ? new Date(value) : null);

    // Update internal state when value prop changes
    useEffect(() => {
        setStartDate(value ? new Date(value) : null);
    }, [value]);

    const handleDateChange = (date) => {
        setStartDate(date);
        if (onChange) {
            // Format date as YYYY-MM-DD for consistency
            const formattedDate = date ? 
                `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}` 
                : null;
            onChange(formattedDate);
        }
    };

    return (
        <div className="datepicker">
            <DatePicker
                selected={startDate}
                onChange={handleDateChange}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText="Date To "
                dateFormat="yyyy-MM-dd"
                maxDate={new Date()}
            />
        </div>
    );
}

function POReceived() {
    // const [value, onChange] = useState(new Date());
    const [startDate, setStartDate] = useState(null);

    return (
        <div className="datepicker">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText="PO Received Date"
            />
        </div>
    );
}

function DateTimePicker() {
    // const [value, onChange] = useState(new Date());
    const [startDate, setStartDate] = useState(new Date());

    return (
        <div className="datepicker">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="YYYYY-MM-DD h:mm aa"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                showTimeSelect={true}
                placeholderText="Date/Time"


            />
            {/* <label data-label="Date/Time" class="form-label"></label> */}
        </div>
    );
}
function FollowUpDate() {
    // const [value, onChange] = useState(new Date());
    const [startDate, setStartDate] = useState(new Date());

    return (
        <div className="datepicker">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText=" "

            />


            <label data-label="Follow-up Date" class="form-label datepick-heading"></label>
        </div>
    );
}

function SurveyDate() {
    // const [value, onChange] = useState(new Date());
    const [startDate, setStartDate] = useState(new Date());

    return (
        <div className="datepicker">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="YYYYY-MM-DD h:mm aa"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText="Survey completed date*"
                showTimeSelect={true}

            />


            <label data-label="Documents Collected date*" class="form-label datepick-heading"></label>
        </div>
    );
}

function SurveCompletedyDate() {
    // const [value, onChange] = useState(new Date());
    const [startDate, setStartDate] = useState(new Date());

    return (
        <div className="datepicker">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="YYYYY-MM-DD h:mm aa"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText="Survey completed date*"
                showTimeSelect={true}

            />


            <label data-label="Survey completed date*" class="form-label datepick-heading"></label>
        </div>
    );
}


function Calendra2() {
    // const [value, onChange] = useState(new Date());
    const [startDate, setStartDate] = useState(null);

    return (
        <div className="datepicker">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText="Date From"
            />
        </div>
    );
}

function StartDateCalendra() {
    // const [value, onChange] = useState(new Date());
    const [startDate, setStartDate] = useState(null);

    return (
        <div className="datepicker">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText=""


            />
            <label data-label="Start Date" class="form-label"></label>
        </div>
    );
}

function EndDateCalendra() {
    // const [value, onChange] = useState(new Date());
    const [startDate, setStartDate] = useState(null);

    return (
        <div className="datepicker">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText=""


            />
            <label data-label="End Date" class="form-label"></label>
        </div>
    );
}

function Timepicker() {
    const [startDate, setStartDate] = useState(new Date());
    return (
        <div className="timepicker-filed">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="h:mm aa"
                placeholderText=" "
            />
            <label data-label="  Follow-up Time" class="form-label datepick-heading"></label>

        </div>
    );
}


function RescheduleDate() {
    // const [value, onChange] = useState(new Date());
    const [startDate, setStartDate] = useState(new Date());

    return (
        <div className="datepicker">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText=""


            />
            <label data-label="Reschedule Date" class="form-label datepick-heading"></label>
        </div>
    );
}

function FromDate() {
    // const [value, onChange] = useState(new Date());
    const [startDate, setStartDate] = useState(null);

    return (
        <div className="datepicker">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText="From Date"
            />
            {/* <label data-label="Date/Time" class="form-label"></label> */}
        </div>
    );
}

function ToDate() {
    // const [value, onChange] = useState(new Date());
    const [startDate, setStartDate] = useState(null);

    return (
        <div className="datepicker">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText="To Date"
            />
            {/* <label data-label="Date/Time" class="form-label"></label> */}
        </div>
    );
}

function FromToDate() {
    // const [value, onChange] = useState(new Date());
    const [startDate, setStartDate] = useState(null);

    return (
        <div className="datepicker">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
            // placeholderText="To Date"
            />
            {/* <label data-label="Date/Time" class="form-label"></label> */}
        </div>
    );
}


function DateRangeSet({ onChange, value }) {
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;

    // Synchronize internal state with value prop for resets
    useEffect(() => {
        if (value && !value.start_date && !value.end_date) {
            setDateRange([null, null]);
        }
    }, [value]);

    const handleDateChange = (update) => {
        setDateRange(update);
        const [start, end] = update;
        if (onChange) {
            const formatDate = (date) => {
                if (!date) return '';
                const d = new Date(date);
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };

            // Format as range: "2026-02-17 - 2026-02-27"
            const formattedStart = formatDate(start);
            const formattedEnd = formatDate(end);
            const dateRangeDisplay = formattedStart && formattedEnd 
                ? `${formattedStart} - ${formattedEnd}`
                : '';

            onChange({
                start_date: formattedStart,
                end_date: formattedEnd,
                display: dateRangeDisplay
            });
        }
    };

    return (
        <div className="datepicker">
            <DatePicker
                startDate={startDate}
                endDate={endDate}
                onChange={handleDateChange}
                selectsRange
                placeholderText="YYYY-MM-DD - YYYY-MM-DD"
                isClearable={true}
            />
        </div>
    );
}




function CalendraSimple() {
    // const [startDate, setStartDate] = useState(new Date());

    // return (
    //     <div className="datepicker">
    //         <DatePicker
    //             selected={startDate}
    //             onChange={(date) => setStartDate(date)}
    //             peekNextMonth
    //             showMonthDropdown
    //             showYearDropdown
    //             dropdownMode="select"
    //         />
    //     </div>
    const [startDate, setStartDate] = useState(new Date());
    return (
        <div className="datepicker">
            <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                showYearPicker
                dateFormat="yyyy"
            />
        </div>
    );


}
export { Calendra, Calendra2, CalendraSimple, StartDateCalendra, EndDateCalendra, DateTimePicker, FollowUpDate, POReceived, SurveyDate, SurveCompletedyDate, Timepicker, RescheduleDate, FromDate, ToDate, FromToDate, DateRangeSet }